import { MainContainer } from "../../component/container";
import { useNavigate } from 'react-router';
import Team from '../../assets/image/tm.jpg'
import BouncingIcon from "../../component/BouncingIcon";
import { Element, Link } from 'react-scroll';
import ICO from '../../assets/ico/charity.png'

export default function Contact() {
    const navigate = useNavigate();

    const Section = ({ title, children }) => {

        return (
            <div className=' text-center  mt-3'>
                <div className="flex flex-col text-center mt-10">
                    <div className='text-center font-extrabold text-lg text-[#2E51A9]'>{title}</div>
                    <div className="flex justify-center mt-5">
                        {children}
                    </div>

                </div>

            </div>

        )
    }


    return (
        <MainContainer page='CONTACT'>
            <div id='content' className="">
                <img src={Team} alt="Team" className='w-screen h-screen object-cover opacity-70' />

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">CONTACT US.</h1>
                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>
            <div className="2xl:px-80 xl:px-52 px-10 mt-24">
                <div className=' text-center  text-[#87ceeb] mt-32'>
                    The acrfi can be contacted via its different teams:
                </div>

                <div className="grid gap-4 lg:grid-cols-2 justify-center">
                    <Section title={'THE ACRFI in MIAMI, FLORIDA'} >
                        <div className="flex items-center justify-center flex-col">
                            <div className="flex items-center gap-2">
                                <span> <span className="text-blue-800 underline cursor-pointer hover:opacity-30" onClick={() => { navigate('/location/team') }}>The Miami Team</span> is the Headquarter of the foundation, located in Miami, Florida.</span>
                            </div>

                            <div className="font-bold text-xl">The ACRFI-MIAMI</div>
                            <span className="">SOKOLONI F. Kamba</span>
                            <span className="">1167 NW 49th street</span>
                            <span className="">Miami, Fl. 33127-2229</span>

                            <span className="mt-5">Tel: 305-607-2284</span>
                            <span className="">Fax: 305-633-0094</span>
                            <span className="">E-mail: admin@theacrfi.org</span>
                            <span className="">www.theacrfi.org</span>


                            <div className="flex items-center gap-2 mt-2">
                                <span className="flex ">The Congolese team is represented in three different States: The Katanga team, the Kasai team & the Kinshasa team.</span>
                            </div>
                        </div>
                    </Section>

                    <Section title={'THE ACRFI in KATANGA / CONGO (DRC)'} >
                        <div className="flex items-center justify-center flex-col">

                            <div className="font-bold text-xl">The ACRFI-KATANGA</div>
                            <span className="">Christine K. Kalomba</span>
                            <span className="">2996 Lac Kipopo, Q.Gambela II</span>
                            <span className="">Commune Lubumbashi</span>
                            <span className="">Katanga, Congo (DRC)</span>

                            <span className="mt-5">Tel: 243-99-873-7019</span>
                            <span className="">Fax: 305-633-0094</span>
                            <span className="">E-mail: admin@theacrfi.org</span>
                            <span className="">www.theacrfi.org</span>
                        </div>
                    </Section>

                    <Section title={'THE ACRFI in KASAI / CONGO (DRC)'} >
                        <div className="flex items-center justify-center flex-col">

                            <div className="font-bold text-xl">The ACRFI-KASAI</div>
                            <span className="">Sr. Margueritte Mudipuekesha</span>
                            <span className="">Soeurs Theresiennes</span>
                            <span className="">2996 Lac Kipopo, Q.Gambela II</span>
                            <span className="">Commune Lubumbashi</span>
                            <span className="">Katanga, Congo (DRC)</span>

                            <span className="mt-5">Tel: 243-99-927-0737 </span>
                            <span className="">Fax: 305-633-0094</span>
                            <span className="">E-mail: admin@theacrfi.org</span>
                            <span className="">www.theacrfi.org</span>
                        </div>
                    </Section>

                    <Section title={'THE ACRFI in KINSHASA / CONGO (DRC)'} >
                        <div className="flex items-center justify-center flex-col">

                            <div className="font-bold text-xl">The ACRFI-KINSHASA</div>
                            <span className="">J.P Ciamala</span>
                            <span className="">17, Avenue Mbandaka, Q/Kingabwa</span>
                            <span className="">C/ LIMETE-KINSHASA</span>
                            <span className="">Katanga, Congo (DRC)</span>

                            <span className="mt-5">Tel: 243-99-812-7675 </span>
                            <span className="">Fax: 305-633-0094</span>
                            <span className="">E-mail: admin@theacrfi.org</span>
                            <span className="">www.theacrfi.org</span>
                        </div>
                    </Section>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center text-blue-400 gap-3">Donate today and make a difference in their lives today! by clicking to this icon <img src={ICO} alt={'ICO'} sizes={40} className="cursor-pointer" /> </div>
                    <div>Or go to: <span className="text-blue-400 hover:underline cursor-pointer" onClick={() => { navigate('/Donate') }}>donate today</span> and choose your best way to give to the work of God!</div>
                </div>
            </div>

        </MainContainer>
    )
}